module.exports = __webpack_public_path__ + "static/img/star_person_service.6d27118a.png";